import { Axios } from "../../../util";
import axios from "axios";

const searchConsentHistoryAPI = async (policyNo,fromDate,toDate) => {
  try {
    const res = await Axios.get(
      `/api/policy/searchConsentHistory?policyNo=${policyNo}&fromDate=${fromDate}&toDate=${toDate}`,
    );
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};

const updateConsent = async (dataUpdate) => {

  try {
      const res = await Axios.post('/api/policy/updateStatusConsent', 
        dataUpdate
      , {
          headers: {
              'Content-Type': 'application/json',
              'authorization': `Bearer ${localStorage.getItem('token_login')}`
          }
      });
      return res.data;
  } catch (error) {
      console.error("There was an error updating the taken data!", error);
      throw error;
  }
};

export { searchConsentHistoryAPI,
         updateConsent
 };
